/**
 * Custom node component for flow visualization
 */

import { Handle, Position } from '@xyflow/react';
import React from 'react';

export type AppNodeData = {
  title: string;
  subtitle?: string;
  icon: React.ReactNode;
};

export const AppNode: React.FC<{ data: AppNodeData; selected?: boolean }> = ({ data, selected }) => {
  const [isHovered, setIsHovered] = React.useState(false);

  return (
    <div
      data-selected={selected ? 'true' : undefined}
      style={{
        background: 'hsl(var(--card))',
        border: selected ? '1px solid #a855f7' : isHovered ? '1px solid #6366f1' : '1px solid hsl(var(--border))',
        borderRadius: 12,
        padding: 12,
        minWidth: 200,
        boxShadow: selected
          ? '0 0 0 2px #d8b4fe'
          : isHovered
            ? '0 4px 12px rgba(99, 102, 241, 0.2), 0 1px 3px rgba(0,0,0,0.1)'
            : '0 1px 2px rgba(0,0,0,0.06), 0 1px 3px rgba(0,0,0,0.1)',
        display: 'flex',
        alignItems: 'center',
        gap: 12,
        cursor: 'pointer',
        transition: 'all 0.2s ease',
      }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <Handle type="target" position={Position.Left} style={{ opacity: 0 }} />
      <Handle id="top" type="target" position={Position.Top} style={{ opacity: 0 }} />
      <div
        style={{
          width: 36,
          height: 36,
          borderRadius: 8,
          background: 'hsl(var(--muted))',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        {data.icon}
      </div>
      <div style={{ lineHeight: 1.1 }}>
        <div style={{ fontWeight: 600, fontSize: 14, color: 'hsl(var(--card-foreground))' }}>{data.title}</div>
        {data.subtitle ? (
          <div style={{ color: 'hsl(var(--muted-foreground))', fontSize: 12 }}>{data.subtitle}</div>
        ) : null}
      </div>
      <Handle type="source" position={Position.Right} style={{ opacity: 0 }} />
      <Handle id="bottom" type="source" position={Position.Bottom} style={{ opacity: 0 }} />
    </div>
  );
};
